export default {
  name: 'Intro',
  // props: {
  //   scroll: Number,
  // },
  data () {
    return {
      fixed: true,
      top: 410,
      right: -705,
    }
  },
  created () {
    if (window.innerWidth > 730) {
      window.addEventListener('scroll', this.handleScroll)
      window.addEventListener('resize', this.handleScroll)
      this.handleScroll()
    }
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.handleScroll)
  },
  methods: {
    handleScroll () {
      if (window.scrollY > 465) {
        this.fixed = false
        this.top = window.innerWidth >= 1260 ? 783
          : window.innerWidth > 960 ? 750
            : window.innerWidth > 834 ? 733
              : window.innerWidth > 730 ? 723
                : 37
        this.right = 0
      } else {
        this.fixed = true
        this.right = -705 - (Math.min(1440, window.innerWidth) - 1440) / 2
        this.top = window.innerWidth >= 1260 ? 410
          : window.innerWidth > 960 ? 379
            : window.innerWidth > 834 ? 362
              : window.innerWidth > 730 ? 352
                : 37
      }
    },
  },
}
